import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getOrders } from '../../services/api';

const MyOrders = () => {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOrders().then(data => { setOrders(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-2xl lg:text-3xl font-bold text-yellow-400 mb-6">My Orders</h1>
      <div className="bg-[#0d1117] border border-[#1a2333] rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#1a2333]">
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Order ID</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">MRS Purchased</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Payment Amount</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Status</th>
                <th className="text-left text-gray-400 text-xs uppercase tracking-wider px-6 py-4">Order Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={5} className="px-6 py-12 text-center text-gray-500">Loading...</td></tr>
              ) : orders.length === 0 ? (
                <tr><td colSpan={5} className="px-6 py-12 text-center text-gray-500">You have not placed any orders yet.</td></tr>
              ) : (
                orders.map((order) => (
                  <tr key={order.id} className="border-b border-[#1a2333] hover:bg-[#1a2333]/50 transition-colors">
                    <td className="px-6 py-4 text-white text-sm font-mono">#{order.id?.slice(-6)}</td>
                    <td className="px-6 py-4 text-white text-sm">{(order.tokensPurchased || 0).toLocaleString()} MRS</td>
                    <td className="px-6 py-4 text-white text-sm">${order.amount}</td>
                    <td className="px-6 py-4">
                      <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${
                        order.status === 'Approved' ? 'bg-green-400/10 text-green-400' :
                        order.status === 'Rejected' ? 'bg-red-400/10 text-red-400' :
                        'bg-yellow-400/10 text-yellow-400'
                      }`}>{order.status}</span>
                    </td>
                    <td className="px-6 py-4 text-gray-400 text-sm">{new Date(order.date).toLocaleDateString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyOrders;
